import Accordion from "@/components/Accordion";
import React from "react";
import { BookAppointment } from "./BookAppointment";
import { Content } from "./Content";
import { CustomAction } from "./CustomAction";
import { ChatWindow } from "../../types";
import ChatWindowPreview from "../../Preview/ChatWindowPreview";
import { ClickToCall } from "./ClickToCall";

interface Props {
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
  setStagedContentWidgetImageFile: (file: File | null) => void;
}

export default function Widgets({ workingChatWindow, setWorkingChatWindow, setStagedContentWidgetImageFile }: Props) {
  const [selectedScreen, setSelectedScreen] = React.useState("Calendly");

  const previewScreens = [
    {
      label: "Calendly",
      action: () => setSelectedScreen("Calendly"),
      name: "Calendly"
    },
    {
      label: "Click to Call",
      action: () => setSelectedScreen("Landing"),
      name: "Landing"
    },
    {
      label: "Content Widget",
      action: () => setSelectedScreen("Content"),
      name: "Content"
    },
    {
      label: "Custom Action",
      action: () => setSelectedScreen("CustomAction"),
      name: "CustomAction"
    }
  ];

  return (
    <div className="panel flex bg-white rounded-2xl shadow-md w-full border">
      <div className="p-6 pb-8 border-r border-slate-300 w-full">
        <div className="text-lg font-medium mb-2">Chat Cards</div>
        <div className="text-sm font-normal text-slate-600 mb-4">
          Customize your chat window with interactive cards. Chat Cards are
          customizable cards for quick access to key features.
        </div>
        <div className="overflow-auto">
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-2">
            Chat Cards
          </div>
          <Accordion>
            <BookAppointment
              onExpanded={() => {
                setSelectedScreen("Calendly");
              }}
              workingChatWindow={workingChatWindow}
              setWorkingChatWindow={setWorkingChatWindow}
            />
            <ClickToCall
              onExpanded={() => {
                setSelectedScreen("Landing");
              }}
              workingChatWindow={workingChatWindow}
              setWorkingChatWindow={setWorkingChatWindow}
            />
            <Content
              onExpanded={() => setSelectedScreen("Content")}
              workingChatWindow={workingChatWindow}
              setWorkingChatWindow={setWorkingChatWindow}
              setStagedContentWidgetImageFile={setStagedContentWidgetImageFile}
            />
            <CustomAction
              onExpanded={() => setSelectedScreen("CustomAction")}
              workingChatWindow={workingChatWindow}
              setWorkingChatWindow={setWorkingChatWindow}
            />
            {/* <KnowledgeBase onExpanded={() => {}} />
            <Call onExpanded={() => {}} /> */}
          </Accordion>
        </div>
      </div>
      <div className="w-full">
        <ChatWindowPreview
          chatWindow={workingChatWindow}
          previewScreens={previewScreens}
          selectedScreen={selectedScreen}
          setSelectedScreen={setSelectedScreen}
        />
      </div>
    </div>
  );
}
